__turbopack_context__.v({
  "hidden": "nNwUgq_hidden",
  "icon": "nNwUgq_icon",
  "iconWithDot": "nNwUgq_iconWithDot",
  "item": "nNwUgq_item",
  "itemActive": "nNwUgq_itemActive",
  "list": "nNwUgq_list",
  "menuItem": "nNwUgq_menuItem",
  "menuItemActive": "nNwUgq_menuItemActive",
  "newsDot": "nNwUgq_newsDot",
  "popup": "nNwUgq_popup",
  "positioner": "nNwUgq_positioner",
  "srOnly": "nNwUgq_srOnly",
  "wrapper": "nNwUgq_wrapper",
});
